export function named(suffix, name) {
    return name && name + '-' + suffix;
}
